module.exports = __webpack_public_path__ + "static/img/HR@3x.5324a758.jpg";